export default {
    SET_MESSAGE_CORRECT: (state, {mensaje,bul}) => {
        state.bulCorrecto = bul
        state.mensaje = mensaje
    },
    SET_MESSAGE_ERROR: (state, {mensaje,bul}) => {
        state.bulError = bul
        state.mensaje = mensaje
    },
    SET_MESSAGE_INFO: (state, {mensaje,bul}) => {
        state.bulInfo = bul
        state.mensaje = mensaje
    },
    SET_BUL_MODAL: (state, bul) => {
        state.bulModal = bul
    },
    SET_IS_OPEN_MANAGMENT_DATA: (state, bul) => {
        state.isOpenManagmentData = bul
    },    
    SET_ERROR_INPUT_REQUIRED: (state, bul) => {
        state.errorAnInputRequired = bul
    },    
    SET_EVENT_SUBMIT: (state, bul) => {
        state.eventSubmit = bul
    },
    SET_LOADER: (state, loaderState) => {
		state.loader = loaderState;
	},
    SET_HEADER_PROFILE: (state, profile) => {
        state.headerProfile = profile;
    },
    SET_NOTIFICATIONS: (state, payload) => {
		state.notifications = payload;
	},
    SET_USERS: (state, payload) => {
		state.users = payload;
	},
    SET_CURRENCIES: (state, payload) => {
		state.currencies = payload;
	},
    SET_CURRENCIES_FILTROS: (state, payload) => {
		state.currenciesFiltered = payload;
	},
    SET_CURRENCY_SELECTED: (state, payload) => {
		state.currencySelected = payload;
	},
    SET_FORMATED_CURRENCIES: (state, payload) => {
        state.currencyFormat = payload;
    },
    setLimitCurrency(state, newValue) {
        state.limitCurrency = newValue;
    },
    incrementLimitCurrency(state) {
        state.limitCurrency++;
    },
}